import React, { useEffect, useState } from 'react';
import { Box, Flex } from 'rebass';
// import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
// import { VoiceRecorder } from "react-voice-recorder-player";
import AudioReactRecorder, { RecordState } from 'audio-react-recorder'
import { HiOutlineMicrophone } from "react-icons/hi2";


function ReactAudioPlayer({ isRecording, onStop, deviceId }) {
    const [recordState, setRecordState] = useState(RecordState.NONE);

    useEffect(() => {
        if (isRecording)
            setRecordState(RecordState.START)
        else
            setRecordState(RecordState.STOP)
    }, [isRecording])

    return <Flex justifyContent="center" alignItems="center" bg="#F5EEF8" sx={{ borderRadius: '4px', width: '100%', height: 300 }}>
        {recordState === RecordState.STOP && <HiOutlineMicrophone size={120} color="#FFFFFF" />}
        <Box sx={{ position: recordState === RecordState.STOP && 'absolute' }}>
            <AudioReactRecorder
                canvasWidth={400}
                canvasHeight={300}
                foregroundColor="#fff"
                backgroundColor="#F5EEF8"
                state={recordState}
                audioTrackConstraints={{
                    deviceId
                }}
                onStop={onStop}
            />
        </Box>
    </Flex>

}

export default ReactAudioPlayer;